import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

/**
 * Share a folder with a school, or with users. Presently only one school may be
 * shared with, but this may change in future (hence it being an array of school ids).
 * Note that if the schools array is populated, the users array should be empty,
 * and vice versa — you cannot share a folder both with a school and individual users.
 * Both arrays may be empty at once to clear any previous shares.
 * @param {Object} config
 * @param {number} config.id - The id of the folder to share
 * @param {number[]} config.schools - Array of schools ids to share the folder with
 * @param {numberp[]} config.users - Array of user ids to share the folder with
 */
const shareFolder = ({ id, schools, users }) =>
  xhr({
    url: `${foldersEndpoint}/${id}/share`,
    method: 'POST',
    data: {
      schools,
      users,
    },
  })

export default shareFolder
